import GMHidden from "../components/gm-hidden";
import SiteMenu from "../components/menu";

export default function HiddenGMPage() {
    return <>
        <SiteMenu />
        <GMHidden />
    </>
}
